// This regex checks for a basic email format:
//  - Local part: allows letters, digits, dots, underscores, percent, plus, hyphen, and apostrophe.
//  - Domain part: allows letters, digits, dots, and hyphens.
//  - TLD: requires at least two letters.
// Note: This does not fully validate all RFC-compliant email addresses, but covers most common real-world cases.
export const isValidEmail = (email: string) =>
  /^[A-Za-z0-9._%+\-']+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i.test(email);

export const validateEmails = (
  input: string,
  existingEmails: string[] = []
): {
  valid: boolean;
  invalidEmails: string[];
  duplicateEmails: string[];
  emails: string[];
} => {
  if (!input.trim())
    return { valid: true, invalidEmails: [], duplicateEmails: [], emails: [] };
  const emails = input
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);

  const invalidEmails = emails.filter((email) => !isValidEmail(email));
  const seen = new Set<string>();
  const duplicateEmails = emails.filter((email) => {
    if (!isValidEmail(email)) return false;
    const lower = email.toLowerCase();
    // Check for duplicates in input and in existing emails
    if (
      seen.has(lower) ||
      existingEmails.some((e) => e.toLowerCase() === lower)
    )
      return true;
    seen.add(lower);
    return false;
  });
  const valid = invalidEmails.length === 0 && duplicateEmails.length === 0;
  return { valid, invalidEmails, duplicateEmails, emails };
};

export const emailsChanged = (
  current: string[],
  original: string[] = []
): boolean => {
  if (original.length !== current.length) return true;
  const sortedOriginal = [...original].sort();
  const sortedCurrent = [...current].sort();
  return sortedOriginal.some((email, idx) => email !== sortedCurrent[idx]);
};
